module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/rowhouse-28282603205cf96c88ce9e6af05bea6a.png";